import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { judgeObj, dealValueShow2, countUp, logColor, dealCarNum, clearObj } from '@/shared/functions';
import Api from '@/services';
import { notification } from 'antd';
import { loading } from '@/components';
import { dispatch } from '@@/store';
const initState = {
    duration: '00:00:00',
    auctionDuration: '00:00:00',
    _count: 0,
    _auctionCount: 0,
    isTheLast: false,
    auctionStartDiffer: 0,
    reservePrice: '',
    currentPrice: '',
    beginPrice: '',
    sceneCount: 0,
    scenePeopleNum: 0,
    netCount: 0,
    netPeopleNum: 0,
    canOperate: false,
    netHight: false,
    showHammerModal: false,
    clickTen: 'no',
    stopTen: true,
    countNum: 10,
    answerPriceStatus: 'hasAnswer',
    showAnswerPriceTip: false,
    alreadyDeal: false,
    alreadyWaitDeal: false,
    alreadyAskPrice: false,
    alreadyAbortive: false,
    currentPriceY: '',
    sessionStatus: '',
    isFormal: false,
    sessionId: '',
    sessionName: '',
    sessionBeginTime: '',
    roundStartDiffer: 0,
    totalCarNum: 0,
    nowNum: '',
    nowCarAuctionId: '',
    stopBtn: false,
    showModal: false,
    disabledStopBtn: false,
    bidStatus: false,
    exceedBasePrice: 0,
    switchCarCountDownTime: 1,
    moreThanTender: 1,
    nextCarNum: '',
    nextCarName: '',
    tenderHighestPriorityOfferY: '',
    tenderHighestPriorityOfferW: '',
    auctionMode: 1,
    auctionStageHasBid: false,
    compareWithTenderDisplay: 1,
    basePriceRemind: 0,
    nearBasePriceRemind: 0,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 获取场次详情 车辆详情 竞拍详情
         */
        load(payload, { update, state, rootState }) {
            const _query = rootState.router.query;
            const _param = {
                roundId: _query.id,
            };
            const { dec, first } = payload;
            this.requestAuctionDetail({ _param, dec, first });
        },
        /**
         * @desc 请求接口
         */
        requestAuctionDetail(payload, { update, state, rootState }) {
            const { _param, dec, first } = payload;
            if (first) {
                loading.show();
            }
            Api.auction.auctioneerDetail(_param).then((_r) => {
                const data = JSON.parse(JSON.stringify(_r));
                if (judgeObj(data)) {
                    const { roundStatus } = data;
                    if (roundStatus === 1) {
                        this.dealNoBegin(data);
                        return;
                    }
                    if (roundStatus === 3) {
                        this.dealEnd(data);
                        return;
                    }
                    if (roundStatus === 2 && judgeObj(data.carInfo) && judgeObj(data.auctionInfo)) {
                        this.dealBegin({ data, dec });
                    }
                }
            }).finally(() => {
                if (first) {
                    loading.hide();
                }
            });
        },
        /**
         * @desc 清除定时器
         */
        resetAndclear() {
            this.CLEAR__COUNT(); // 清除车辆竞拍时间
            this.CLEAR_Auction_COUNT(); // 清除场开拍时间
            this.CLEAR__COUNT_Down(); // 清除倒计时
            this.RESET_STATE(); // 清除状态
        },
        /**
         * @desc 清除定时器
         */
        resetAndclear2() {
            this.CLEAR__COUNT(); // 清除车辆竞拍时间
            this.CLEAR_Auction_COUNT(); // 清除场开拍时间
            this.CLEAR__COUNT_Down(); // 清除倒计时
            this.RESET_STATE2(); // 清除除场次状态之外的状态
        },
        resetAndclear3() {
            this.CLEAR__COUNT_Down(); // 清除倒计时
            this.SET_STATE({
                alreadyAbortive: false,
                alreadyWaitDeal: false,
                alreadyDeal: false,
                alreadyAskPrice: false,
            });
        },
        resetAndclear4(payload, { update, state, rootState }) {
            this.CLEAR__COUNT(); // 清除车辆竞拍时间
            this.CLEAR__COUNT_Down(); // 清除倒计时
            this.RESET_STATE3(state, {}); // 清除除场次状态之外的状态
        },
        /**
         * @desc 场次未开始
         */
        dealNoBegin(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.resetAndclear({});
                const { roundName, productNum, roundStartTime, roundId, } = payload;
                this.SET_STATE({
                    sessionStatus: 'noBegin',
                    sessionBeginTime: roundStartTime,
                    sessionName: roundName,
                    totalCarNum: productNum,
                    sessionId: roundId,
                });
            });
        },
        /**
         * @desc 场次已结束
         */
        dealEnd(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.resetAndclear({});
                const { roundId } = payload;
                this.SET_STATE({
                    sessionStatus: 'end',
                    sessionId: roundId,
                });
            });
        },
        /**
         * @desc 场次竞拍中
         */
        dealBegin(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, dec } = payload;
                if (dec === 'during') {
                    yield this.resetAndclear3({});
                }
                else if (dec === 'next') {
                    yield this.resetAndclear4({});
                }
                else {
                    yield this.resetAndclear2({});
                }
                const { roundId, carInfo, auctionInfo, theLastCar, roundStartDiffer, productNum, roundSimulateStatus, auctionId, auctionStartDiffer, switchCarCountDownTime, nextAuctionSerialNumber, nextCarName, auctionMode, } = data;
                const { auctionSerialNumber } = carInfo;
                const { basePriceW, auctionPriceW, priorityOfferW, sceneBidNumber, sceneBidPeople, remoteBidNumber, remoteBidPeople, highestPriceSource, countdownStatus, leftTime, inquiryTag, priorityOfferY, status, bidStatus, exceedBasePrice, auctionStageHasBid, moreThanTender, tenderHighestPriorityOfferY, tenderHighestPriorityOfferW, compareWithTenderDisplay, basePriceRemind, nearBasePriceRemind, } = auctionInfo;
                /**
                 *  _canOpt：操作区展示 _clickT：倒计时展示  _answerS：应价状态
                 *  _stopTen 倒计时true暂停还是false继续 _disabledStopBtn: 暂停拍卖禁用状态
                 * _stopStatus: 场次是否暂停
                 */
                let _canOpt = false;
                let _clickT;
                let _answerS;
                let _stopTen;
                let _disabledStopBtn;
                let _stopStatus;
                switch (status) {
                    case 30: // 竞拍暂停中
                        _clickT = countdownStatus === 0 ? 'no' : 'begin';
                        _stopTen = countdownStatus === 1 ? false : true;
                        break;
                    case 81: // 加价师应价中
                    case 8: // 应价
                        _canOpt = true;
                        _clickT = 'answer';
                        _stopTen = true;
                        this.ALREADY_ASKPRICE();
                        break;
                    case 80: // 应价暂停中
                        _canOpt = true;
                        _clickT = 'answer';
                        _stopTen = false;
                        this.ALREADY_ASKPRICE();
                        break;
                    case 50: // 待成交
                        _canOpt = true;
                        _clickT = 'end';
                        this.ALREADY_WAIT_DEAL();
                        break;
                    case 51: // 应价待成交
                        _canOpt = true;
                        _clickT = 'end';
                        this.ALREADY_ASKPRICE();
                        _answerS = 'noAnswer';
                        break;
                    case 3: // 竞拍中
                        _clickT = countdownStatus === 0 ? 'no' : 'begin';
                        _stopTen = true;
                        break;
                    case 4: // 结束
                        _canOpt = true;
                        _clickT = 'end';
                        break;
                    case 5: // 成交
                        _canOpt = true;
                        _clickT = 'end';
                        // 判断是应价成交 还是成交
                        if (inquiryTag) {
                            this.ALREADY_ASKPRICE();
                            _answerS = 'hasAnswer';
                        }
                        else {
                            this.ALREADY_DEAL();
                        }
                        break;
                    case 6: // 流拍
                        _canOpt = true;
                        _clickT = 'end';
                        this.ALREADY_ABORTIVE();
                        break;
                }
                _stopStatus = status === 30 ? (countdownStatus === 1 ? false : true) : false;
                // 拍卖暂停是否置灰 如竞拍中未开启倒计时以及点击暂停拍卖
                _disabledStopBtn = status === 3 && countdownStatus === 0 ? false : _stopStatus ? false : true;
                // 赋值操作：如值非undefined则赋值，否则展示原有值
                const temp = {
                    sessionId: roundId,
                    auctionStartDiffer,
                    roundStartDiffer,
                    totalCarNum: productNum,
                    sessionStatus: 'begin',
                    isFormal: roundSimulateStatus === 0 ? true : false,
                    nowNum: auctionSerialNumber,
                    nowCarAuctionId: auctionId,
                    isTheLast: theLastCar,
                    reservePrice: basePriceW,
                    currentPrice: priorityOfferW,
                    currentPriceY: priorityOfferY,
                    beginPrice: auctionPriceW,
                    bidStatus,
                    sceneCount: dealValueShow2(sceneBidNumber),
                    scenePeopleNum: dealValueShow2(sceneBidPeople),
                    netCount: dealValueShow2(remoteBidNumber),
                    netPeopleNum: dealValueShow2(remoteBidPeople),
                    netHight: highestPriceSource === 1 ? true : false,
                    canOperate: _canOpt,
                    stopTen: _stopTen,
                    clickTen: _clickT,
                    countNum: leftTime,
                    answerPriceStatus: _answerS,
                    stopBtn: _stopStatus,
                    disabledStopBtn: _disabledStopBtn,
                    exceedBasePrice,
                    switchCarCountDownTime,
                    moreThanTender,
                    nextCarNum: dealCarNum(nextAuctionSerialNumber),
                    nextCarName,
                    tenderHighestPriorityOfferY,
                    tenderHighestPriorityOfferW,
                    auctionMode,
                    auctionStageHasBid,
                    compareWithTenderDisplay,
                    basePriceRemind,
                    nearBasePriceRemind,
                };
                this.SET_STATE(Object.assign({}, clearObj(temp)));
                if (dec !== 'during') {
                    if (dec !== 'next') {
                        // 开始场次竞拍时间
                        this.auctionCountUp({});
                    }
                    // 开始车辆竞拍时间
                    this.countUp({});
                }
                // 竞价倒计时
                if (status === 3 && countdownStatus) {
                    this.goToCount({ countNum: leftTime, type: 'duringAuction' });
                }
                // 应价倒计时
                if (status === 81 || status === 8) {
                    this.goToCount({ countNum: leftTime, type: 'duringAnswer' });
                }
                // 有车辆竞拍结果
                if (status === 5 || status === 50 || status === 51 || status === 6) {
                    this.dealHasResult({ num: leftTime });
                }
            });
        },
        /**
         * @desc 车结果推送
         */
        carResult(payload, { update, state, rootState }) {
            logColor('拍卖师收到车结果推送了哦', payload, 'color: magenta');
            const { status, countNum, priorityOfferW, exceedBasePrice, moreThanTender } = payload;
            // 正式拍卖
            if (rootState.auctionOperate.isFormal) {
                this.dealHasResult({ num: countNum, status, priorityOfferW, exceedBasePrice, moreThanTender });
            }
            // 模拟拍卖
            else {
                this.SHOW_BEGIN_MODAL();
            }
        },
        /**
         * @desc 出价推送
         */
        price(payload, { update, state, rootState }) {
            logColor('拍卖师收到出价推送了哦', payload, 'color: magenta');
            const { priorityOfferW, priorityOfferY, auctionPriceW, sceneBidNumber, sceneBidPeople, remoteBidNumber, remoteBidPeople, bidType, countNum, countDownStatus, status, exceedBasePrice, moreThanTender, } = payload;
            // 赋值 远程和现场的出价次数|出价人数|谁出的最高价
            this.SET_STATE({
                currentPrice: priorityOfferW,
                currentPriceY: priorityOfferY,
                beginPrice: auctionPriceW,
                sceneCount: dealValueShow2(sceneBidNumber),
                scenePeopleNum: dealValueShow2(sceneBidPeople),
                netCount: dealValueShow2(remoteBidNumber),
                netPeopleNum: dealValueShow2(remoteBidPeople),
                netHight: bidType === 1 ? true : false,
                bidStatus: true,
                auctionStageHasBid: true,
                exceedBasePrice,
                moreThanTender,
            });
            if (status === 3 && countDownStatus === 1) {
                this.SET_STATE({
                    countNum,
                });
                this.goToCount({ countNum, type: 'duringAuction' });
            }
            if (status === 30) {
                this.CLEAR__COUNT_Down();
            }
        },
        /**
         * @desc 结束推送
         */
        roundStatus(payload, { update, state, rootState }) {
            logColor('拍卖师收到场次状态变更推送了哦', payload, 'color: magenta');
            // 判断是否是场次变更为结束或撤销状态了，如果是，处理为已结束，如果不是，不care
            const { roundId, roundStatus } = payload;
            if (roundId && (roundStatus === 3 || roundStatus === 4)) {
                this.dealEnd({ roundId });
            }
        },
        /**
         * @desc 下架推送
         */
        priviewCarDown(payload, { update, state, rootState }) {
            logColor('拍卖师收到下架推送了哦', payload, 'color: magenta');
            const { carCount } = payload;
            this.SET_STATE({
                totalCarNum: carCount,
            });
        },
        /**
         * @desc 添加车辆推送
         */
        addCar(payload, { update, state, rootState }) {
            logColor('拍卖师收到添加车辆推送了哦', payload, 'color: magenta');
            const { carCount } = payload;
            this.SET_STATE({
                totalCarNum: carCount,
            });
        },
        /**
         * @desc 立即结束竞拍接口
         */
        immediatelyEnd(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId } = state;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
            };
            Api.auction.auctionEnd(_param).then((_r) => {
                const data = JSON.parse(JSON.stringify(_r));
                if (judgeObj(data)) {
                    // 优化：针对竞拍结束之后漏收到价格推送的情况，更新最新价格信息
                    const { priorityOfferW, priorityOfferY, sceneBidNumber, sceneBidPeople, remoteBidNumber, remoteBidPeople, highestPriceSource, bidStatus, auctionStageHasBid, exceedBasePrice, moreThanTender, } = data;
                    this.SET_STATE({
                        currentPrice: priorityOfferW,
                        currentPriceY: priorityOfferY,
                        sceneCount: dealValueShow2(sceneBidNumber),
                        scenePeopleNum: dealValueShow2(sceneBidPeople),
                        netCount: dealValueShow2(remoteBidNumber),
                        netPeopleNum: dealValueShow2(remoteBidPeople),
                        netHight: highestPriceSource === 1 ? true : false,
                        bidStatus,
                        auctionStageHasBid,
                        exceedBasePrice,
                        moreThanTender,
                    });
                    // 样式展示--已结束 暂停拍卖不可点击 依据情况出现操作按钮
                    this.SET_CLICKTEN('end');
                    this.true_disabledStopBtn();
                    this.TRUE_CAN_OPERATE();
                    // 优化：针对竞拍结束之后漏收到价格推送的情况，更新大屏详情
                    dispatch.screen.load({});
                }
            });
        },
        /**
         * @desc 点击可配置秒数倒计时
         */
        beginTen(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId, countNum } = state;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
            };
            Api.auction.startCountDown(_param).then((_r) => {
                if (_r) {
                    this.SET_CLICKTEN('begin');
                    this.TRUE_STOP_TEN();
                    this.true_disabledStopBtn();
                    this.goToCount({ countNum, type: 'duringAuction' });
                }
            });
        },
        /**
         * @desc 点击10s倒计时暂停
         */
        stopTen(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId } = rootState.auctionOperate;
            const { countNum } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
                countdownRemainingTime: countNum,
            };
            console.log('暂停开始发送接口');
            console.log('清除前state._countdown', state._countDown);
            this.CLEAR__COUNT_Down();
            Api.auction.pauseCountDown(_param).then((_r) => {
                if (_r) {
                    console.log('暂停已完成');
                    console.log('暂停已完成清除前state._countdown', state._countDown);
                    this.CLEAR__COUNT_Down();
                    this.FALSE_STOP_TEN();
                }
            }).catch((_e) => {
                console.log('请求10s倒计时暂停接口有错误', _e);
                this.goToCount({ countNum, type: 'duringAuction' });
            });
        },
        /**
         * @desc 点击10s倒计时继续
         */
        goOnTen(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
            };
            Api.auction.continueCountDown(_param).then((_r) => {
                const _d = JSON.parse(JSON.stringify(_r));
                if (judgeObj(_d)) {
                    const { success, countdownRemainingTime } = _d;
                    if (success) {
                        this.TRUE_STOP_TEN();
                        this.SET_COUNT_NUM(countdownRemainingTime);
                        this.goToCount({ countNum: countdownRemainingTime, type: 'duringAuction' });
                    }
                }
            });
        },
        /**
         * @desc 点击成交
         */
        optDeal(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
            };
            Api.auction.clinch(_param).then((_r) => {
                if (_r) {
                    notification.success({
                        message: '该车辆成交成功',
                    });
                    this.ALREADY_DEAL();
                    // 考虑推送结果会比请求结果更快，处理不再附加，都更新为推送结果的处理
                    this.dealHasResult({ status: 5 });
                }
            });
        },
        /**
         * @desc 点击待成交
         */
        optWaitDeal(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
            };
            Api.auction.pendingTransaction(_param).then((_r) => {
                if (_r) {
                    notification.success({
                        message: '该车辆待成交成功',
                    });
                    this.ALREADY_WAIT_DEAL();
                    // 考虑推送结果会比请求结果更快，处理不再附加，都更新为推送结果的处理
                    this.dealHasResult({ status: 50 });
                }
            });
        },
        /**
         * @desc 点击流拍
         */
        optAbortive(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
            };
            Api.auction.failAuction(_param).then((_r) => {
                if (_r) {
                    notification.success({
                        message: '该车辆流拍成功',
                    });
                    this.ALREADY_ABORTIVE();
                    // 考虑推送结果会比请求结果更快，处理不再附加，都更新为推送结果的处理
                    this.dealHasResult({ status: 6 });
                }
            });
        },
        /**
         * @desc 点击询价
         */
        optAskPrice(payload, { update, state, rootState }) {
            // 弹出应锤价窗口
            this.SHOW_HAMMER_MODAL();
        },
        /**
         * @desc 倒计时 倒计时和应价倒计时以及正式竞拍中下一辆车的倒计时
         */
        countDown(payload, { update, state, rootState }) {
            this.CLEAR__COUNT_Down();
            let { num } = payload;
            const { type } = payload;
            const _count = setInterval(() => {
                if (num > 1) {
                    num -= 1;
                    this.SET_COUNT_NUM(num);
                }
                else {
                    this.HIDE_ANSWERPRICE_TIP();
                    this.CLEAR__COUNT_Down();
                    switch (type) {
                        case 'duringAuction':
                        case 'duringAnswer':
                            this.load({ dec: 'during' });
                            break;
                        case 'duringEndCar':
                            this.endCar({});
                            break;
                    }
                }
            }, 1000);
            this.SET__COUNT_Down(_count);
        },
        /**
         * @desc 进入倒计时
         */
        goToCount(payload) {
            const { countNum, type } = payload;
            if (countNum > 0) {
                this.countDown({ num: countNum, type });
            }
            else if (type && countNum < 0) {
                let _msg;
                switch (type) {
                    case 'duringAuction':
                        _msg = '竞拍倒计时，服务端返回秒数不正确';
                        break;
                    case 'duringAnswer':
                        _msg = '应价倒计时，服务端返回秒数不正确';
                        break;
                    case 'duringEndCar':
                        _msg = '下一辆车倒计时，服务端返回秒数不正确';
                        break;
                }
                notification.error({
                    message: _msg,
                });
            }
        },
        /**
         * @desc 车辆倒计时已结束
         */
        endCar(payload, { update, state, rootState }) {
            const { isTheLast, sessionId } = state;
            if (isTheLast) {
                this.dealEnd({ roundId: sessionId });
            }
            else {
                this.load({ dec: 'next' });
                // 请求下一辆车的时候就刷新页面
                dispatch.screen.load({});
            }
        },
        /**
         * @desc 主动顺计时 车辆竞拍时间
         */
        countUp(payload, { update, state, rootState }) {
            let { auctionStartDiffer } = state;
            auctionStartDiffer = auctionStartDiffer || 0;
            const _count = setInterval(() => {
                auctionStartDiffer += 1;
                this.SET_DURATION(countUp(auctionStartDiffer));
            }, 1000);
            this.SET__COUNT(_count);
        },
        /**
         * @desc 主动顺计时 场次竞拍时间
         */
        auctionCountUp(payload, { update, state, rootState }) {
            let { roundStartDiffer } = state;
            roundStartDiffer = roundStartDiffer || 0;
            const _count = setInterval(() => {
                roundStartDiffer += 1;
                this.SET_auction_DURATION(countUp(roundStartDiffer));
            }, 1000);
            this.SET_Auction_COUNT(_count);
        },
        /**
         * @desc 处理车辆已经出现竞拍结果 成交|流拍|待成交|应价待成交
         */
        dealHasResult(payload, { update, state, rootState }) {
            const { switchCarCountDownTime } = state;
            const { num = switchCarCountDownTime, status, priorityOfferW, exceedBasePrice, moreThanTender } = payload;
            const { isFormal, alreadyAskPrice } = state;
            if (!isFormal) {
                this.SHOW_BEGIN_MODAL();
            }
            else {
                if (num === 0) {
                    setTimeout(() => {
                        this.load({});
                    }, 1000);
                    console.error('接口返回该车辆已有操作结果但剩余时间为0，所以会持续刷详情');
                    return;
                }
                this.SET_COUNT_NUM(num);
                this.SET_CLICKTEN('end');
                // 赋值 应价状态|保留价关系|投标价关系|当前价 answerPriceStatus | exceedBasePrice | moreThanTender | currentPrice
                const _state = {};
                if (exceedBasePrice !== undefined) {
                    _state.exceedBasePrice = exceedBasePrice;
                }
                if (moreThanTender !== undefined) {
                    _state.moreThanTender = moreThanTender;
                }
                if (priorityOfferW !== undefined) {
                    _state.currentPrice = priorityOfferW;
                }
                // 查看是否是应价结果
                if (status === 5 || status === 51) {
                    const answerPriceStatus = status === 5 ? 'hasAnswer' : 'noAnswer';
                    _state.answerPriceStatus = answerPriceStatus;
                    /** 去除应价提示框的展示，但考虑后续业务的拓展，暂时不删除应价提示的功能 */
                    // if (alreadyAskPrice) {
                    //   this.SHOW_ANSWERPRICE_TIP();
                    // }
                }
                this.SET_STATE(Object.assign({}, _state));
                this.goToCount({ countNum: num, type: 'duringEndCar' });
            }
        },
        /**
         * @desc 点击模拟拍卖
         */
        clickedSimulate(payload, { update, state, rootState }) {
            const { sessionId } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                simulateTag: 1,
            };
            Api.auction.startAuction(_param).then((_r) => {
                if (_r) {
                    this.load({ first: true });
                }
            });
        },
        /**
         * @desc 点击正式拍卖
         */
        clickedFormal(payload, { update, state, rootState }) {
            const { sessionId } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                simulateTag: 0,
            };
            Api.auction.startAuction(_param).then((_r) => {
                if (_r) {
                    this.load({ first: true });
                }
            });
        },
        /**
         * @desc 点击暂停拍卖
         */
        stopAuction(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
            };
            Api.auction.stopAuction(_param).then((_r) => {
                if (_r) {
                    this.STOP_AUCTION();
                }
            });
        },
        /**
         * @desc 点击继续拍卖
         */
        goOnAuction(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId } = rootState.auctionOperate;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
            };
            Api.auction.goOnAuction(_param).then((_r) => {
                if (_r) {
                    this.GOON_AUCTION();
                }
            });
        },
        /**
         * @desc 点击切车
         */
        switchCar(payload, { update, state, rootState }) {
            const { sessionId, nowCarAuctionId, alreadyAbortive, alreadyDeal, alreadyWaitDeal } = rootState.auctionOperate;
            if (alreadyAbortive || alreadyDeal || alreadyWaitDeal) {
                notification.success({
                    message: '切车成功',
                });
                this.load({ dec: 'next' });
                dispatch.screen.load({});
                Api.longLink.reLong();
                return;
            }
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
                switchCar: true,
            };
            Api.auction.failAuction(_param).then((_r) => {
                if (_r) {
                    notification.success({
                        message: '切车成功',
                    });
                    this.ALREADY_ABORTIVE();
                    this.load({ dec: 'next' });
                    dispatch.screen.load({});
                    Api.longLink.reLong();
                }
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        RESET_STATE2() {
            return Object.assign(Object.assign({}, initState), { sessionStatus: 'begin' });
        },
        RESET_STATE3(state) {
            return Object.assign(Object.assign({}, initState), { sessionStatus: 'begin', auctionDuration: state.auctionDuration, _auctionCount: state._auctionCount });
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SHOW_HAMMER_MODAL(state) {
            state.showHammerModal = true;
        },
        HIDE_HAMMER_MODAL(state) {
            state.showHammerModal = false;
        },
        SET_CLICKTEN(state, payload) {
            state.clickTen = payload;
        },
        TRUE_STOP_TEN(state) {
            state.stopTen = true;
        },
        FALSE_STOP_TEN(state) {
            state.stopTen = false;
        },
        SET_COUNT_NUM(state, payload) {
            state.countNum = payload;
        },
        TRUE_CAN_OPERATE(state) {
            state.canOperate = true;
        },
        FALSE_CAN_OPERATE(state) {
            state.canOperate = false;
        },
        SHOW_ANSWERPRICE_TIP(state) {
            state.showAnswerPriceTip = true;
        },
        HIDE_ANSWERPRICE_TIP(state) {
            state.showAnswerPriceTip = false;
        },
        ALREADY_DEAL(state) {
            state.alreadyDeal = true;
        },
        ALREADY_WAIT_DEAL(state) {
            state.alreadyWaitDeal = true;
        },
        ALREADY_ASKPRICE(state) {
            state.alreadyAskPrice = true;
        },
        ALREADY_ABORTIVE(state) {
            state.alreadyAbortive = true;
        },
        SET_DURATION(state, payload) {
            state.duration = payload;
        },
        SET_auction_DURATION(state, payload) {
            state.auctionDuration = payload;
        },
        SET__COUNT(state, payload) {
            state._count = payload;
        },
        CLEAR__COUNT(state) {
            clearInterval(state._count);
            state._count = 0;
        },
        SET__COUNT_Down(state, payload) {
            state._countDown = payload;
        },
        CLEAR__COUNT_Down(state) {
            clearInterval(state._countDown);
            state._countDown = 0;
        },
        SET_AUCTION_STATUS(state, payload) {
            state.sessionStatus = payload;
        },
        STOP_AUCTION(state) {
            state.stopBtn = true;
        },
        GOON_AUCTION(state) {
            state.stopBtn = false;
        },
        SHOW_BEGIN_MODAL(state) {
            state.showModal = true;
        },
        HIDE_BEGIN_MODAL(state) {
            state.showModal = false;
        },
        SET_Auction_COUNT(state, payload) {
            state._auctionCount = payload;
        },
        CLEAR_Auction_COUNT(state) {
            clearInterval(state._auctionCount);
            state._auctionCount = 0;
        },
        true_disabledStopBtn(state) {
            state.disabledStopBtn = true;
        },
    },
});
